import React from "react";
import {ConfigItem} from "components/user/configuration/ConfigItem";
import {images} from "assets/img/user/configuration.js";
import "assets/sass/user/configuration/Configuration.scss";

export class LanguageConfiguration extends React.Component {
    render() {
        return (
            <ConfigItem
                title="Idioma"
                subtitle="Español"
                icon={images.language}>
            </ConfigItem>
        )
    }
}
